import { Product } from './../../../../models/product.model';
import {Component, OnInit} from '@angular/core';
import {PublicationService} from "../../../../services/publication.service";
import {IPost, Post} from "../../../../models/post.model";
import Swal from "sweetalert2";
import { BsModalService } from 'ngx-bootstrap/modal';
import {environment} from "../../../../environments/environment";
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {Note} from "../../../../models/NotePost";
import * as XLSX from "xlsx";
import {DatePipe} from "@angular/common";
import {ProductService} from "../../../../services/product.service";
import { ParamService } from '../../../../services/param.service';
import { Param } from '../../../../models/param.model';
import { PostPromoteService } from '../../../../services/postPromote.service';
import { Observable } from 'rxjs';
import { AddPromoteComponent } from '../kahpoo-shop/post-promote/add-promote/add-promote.component';
import { ServiceService } from '../../../../services/service.service';
import { PostService } from '../../../../services/post.service';
import { PromotionApplyService } from '../../../../services/promotion_apply.service';
import { Promotion } from '../../../../models/promotion.model';
import { TypeOffer } from '../../../../models/typeOffer.model';
import { TypeOfferService } from '../../../../services/typeOffer.service';
import { PromotionService } from '../../../../services/promotion.service';
import { SubProductCharacteristic } from '../../../../models/subProductCharacteristic.model';

@Component({
  selector: 'app-publications2',
  templateUrl: './publications2.component.html',
  styleUrls: ['./publications2.component.scss']
})
export class PublicationsComponent2 implements OnInit {
  selectedOfferType : TypeOffer;
  posts: Post[] = [];
  postTampons: Post[] = [];
  initialPosts: Post[] = [];
  pageNumber: number = 1;
  pageSize: number = 10;
  totalItems :any;
  imageName: string | undefined = '';
  post!: Post;
  product!: Product;
  postUpdate!: Post;
  nbTotalPurchase: number = 0;
  url_photo: String;
  selected: boolean = false;
  unitTime: string [] = [];
  notePosts: Note[] = [];
  isHighlighted$: Observable<boolean>;
  search: any;
  postId: number;
  allowDeliveryChecked: boolean = false;
    // @ts-ignore
    public modalRef: BsModalRef;
  highlightedPosts:any[] = [];
  param: Param;
  paramPromo: Param;
  annonceEnPromotionDeKahpoo:any[] = [];
  kahooProductPromotionId :any;
  productPromotionId: any;
  kahooServicePromotionId :any;
  servicePromotionId :any;
  listKahpooPromo: any
  selectedPromotion: Promotion;
  postPromu: any;
  subProductCharact: SubProductCharacteristic [] = [];
  statusSearchText = '';
  searchText = '';
  constructor(private promotionService: PromotionService,
              private typeOfferService: TypeOfferService,
              private promotionApplyService: PromotionApplyService,
              private postService: PublicationService,
              private postServicePost: PostService,
              private productService: ProductService,
              private servService:ServiceService,
              private fb: FormBuilder,
              private router: Router,
              private modalService: BsModalService,
              private datePipe: DatePipe, private paramService: ParamService, private postPromoteService: PostPromoteService) {
    this.unitTime = ['Minutes', 'Heurs', 'Jours', 'Mois'];
  }

  ngOnInit(): void {
    this.allPosts();
    this.url_photo = environment.url_photo;
    this.testIfIsKahpooProductPromotion();
    this.testIfIsKahpooServicePromotion();
    this.annoneMiseEnAvant();
    this.listeAnnoncesEnPromotionDeKahpoo();

   // this.isHighlighted$ = this.isIdInHighlightedPostsNew(this.postId);

  }

  dateForm = this.fb.group({
    beginDate: new FormControl(''),
    endDate: new FormControl('')
  })

  updateProdFormGroup = this.fb.group({
    name: new FormControl('', [Validators.required]),
    description: new FormControl('', [Validators.required]),
    /*allowDelivery: new FormControl(null),
    pickFormShop: new FormControl(null),
    unitDeliveryDuration: new FormControl(''),
    deliveryDelay: new FormControl(''),*/
  });

  updateServFormGroup = this.fb.group({
    /*price: new FormControl('', [Validators.required]),*/
    name: new FormControl('', [Validators.required]),
    description: new FormControl('', [Validators.required])
  });

  testIfIsKahpooProductPromotion():number{
    this.postService.isKahpooProductPromotion().subscribe(rs=>{
      if(rs){
        // console.log("rs promo active", rs)
        this.productPromotionId = rs
        this.kahooProductPromotionId = rs[0].id;
      }else{
        window.localStorage.removeItem("csa-tabbed-prowsing");
      }
    })
    return this.kahooProductPromotionId;
  }

  testIfIsKahpooServicePromotion(){
    this.postService.isKahpooServicePromotion().subscribe(rs=>{
      if(rs){
        this.servicePromotionId = rs
        this.kahooServicePromotionId =rs[0].id;
      }else{
        window.localStorage.removeItem("csa-tabbed-srowsing");
      }

    })
  }

  isFilterByProduct: boolean = false;
  isFilterByService: boolean = false;
  isFilterByProductAndService: boolean = true;

  allPosts() {
      this.posts = [];
      this.searchText = this.search !== undefined ? this.search : '';
      this.postService.allSellerPosts(this.pageNumber-1, this.pageSize, this.isFilterByProductAndService, this.isFilterByService, this.isFilterByProduct, this.beginDateVal, this.endDateVal, this.searchText, this.statusSearchText).subscribe(data => {
      this.posts = data.content;
      this.totalItems = data.totalElements;
      // console.log("Liste des publications...")
      // console.log(this.posts)
      this.posts = this.filterByGiftCard(this.posts);
      this.initialPosts = this.posts;
      this.postTampons = this.posts;
    })
  }

  filterByGiftCard(publications: any[]): any[] {
    return publications.filter(pub => pub?.category?.name != 'Carte cadeaux');
  }

  enablePost(postId: number) {
    this.postServicePost.activePostBack(postId).subscribe(data => {
    //  console.log("data.........................");
    //  console.log(data);
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Publication modifiée avec succès',
        showConfirmButton: false,
        timer: 1500
      });
      this.allPosts();
    }, error => {
     // console.log(error);
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Erreur lors de la modification de la publication"',
        showConfirmButton: false,
        timer: 1500
      });
    })
  }

  disablePost(postId: number) {
    this.postService.disablePost(postId).subscribe(data => {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Publication modifiée avec succès"',
        showConfirmButton: false,
        timer: 1500
      });
      this.allPosts();
      this.postPromoteService.deletePromoteFromPostId(postId).subscribe(result=>{
        this.reloadComponent();
      })
    }, error => {
     // console.log(error);
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Erreur lors de la modification de la publication"',
        showConfirmButton: false,
        timer: 1500
      });
    })
  }

  postDetails(p: Post) {
  //  console.log("Détails du service...");
  //  console.log(p);
    this.postService.totalPurchase(p.id).subscribe(data => {
      this.nbTotalPurchase = data;
    }, error => {
    //  console.log(error);
    });

    this.postService.getIdPost(p.id).subscribe(post =>{
      this.post = post;
      if(this.post.postSubProducts[0] != null || this.post.postSubProducts[0] != undefined) {
        this.subProductCharact =this.post.postSubProducts[0].subProduct.subProductCharacteristics

        // console.log("error", this.subProductCharact);
      }
      
    });

    // Récupérer le détail de l'annonce
    if (p.postSubProducts.length > 0) {
      this.productService.getSubProductbyProductId(p.postSubProducts[0].subProduct.subProductID).subscribe(value => {
        this.product = value;
      })
    }


    this.getNotesAndCommentByPostId(p.id);
  }

  getNotesAndCommentByPostId(id: number){
    this.postService.notesAndCommentsByPostId(id).subscribe(data => {
      this.notePosts = data;
    }, error => {
    //  console.log(error);
    })
  }

  productUpdated  :Product;
  serviceUpdated  :any;
  handleUpdate(id: number) {

    this.postService.getPostById(id).subscribe(rs => {
      this.postUpdate = rs;

     // console.log("Annonce à modifier début.....");
     // console.log(this.postUpdate);
      // console.log("Id du produit à modifier")
      // console.log(this.postUpdate.postSubProducts[0].subProduct.productID);
      // this.productService.getProductbyProductId(this.postUpdate.postSubProducts[0].subProduct.productID).subscribe(product => {
      if(this.postUpdate.postSubProducts.length>0){
        this.productService.getProductbyProductId(this.postUpdate.postSubProducts[0].subProduct.productID).subscribe(product => {


          this.productService.getIdProduct(product.id).subscribe(rs=>{
            this.productUpdated = rs;
           // console.log("Annonce à modifier .....");
           // console.log(this.productUpdated);

            // if (this.postUpdate.postProducts.length > 0) {
            //   this.updateProdFormGroup.patchValue({
            //     /*price: post.postProducts[0].price,*/
            //     description: this.postUpdate.description
            //   });
            // }
            if (this.postUpdate && this.productUpdated) {
              this.updateProdFormGroup.patchValue({
                /*price: post.postProducts[0].price,*/
                name: this.productUpdated.name,
                description: this.postUpdate.description
              });
            }
          })

        });
      }
      if (this.postUpdate.postServiceModels.length > 0) {
        this.serviceUpdated = this.postUpdate.postServiceModels[0].serviceModel;

        this.updateServFormGroup.patchValue({
          /*price: post.postServiceModels[0].price,*/
          name: this.postUpdate.postServiceModels[0].serviceModel.titre,
          description: this.postUpdate.description
        });
      }
    })
  }

  updatePubProd() {
    const name = this.updateProdFormGroup.get(['name']).value;
    const description = this.updateProdFormGroup.get(['description']).value;

    /*const allowDelivery = this.updateProdFormGroup.get(['allowDelivery']).value;
    const pickFormShop = this.updateProdFormGroup.get(['pickFormShop']).value;
    const unitDeliveryDuration = this.updateProdFormGroup.get(['unitDeliveryDuration']).value;
    const deliveryDelay = this.updateProdFormGroup.get(['deliveryDelay']).value;*/

    /*if (this.allowDeliveryChecked && unitDeliveryDuration == null && this.allowDeliveryChecked && deliveryDelay == null) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner l\'unité de temps et le délais de livraison',
        showConfirmButton: false,
        timer: 1500
      });
    } else if (this.allowDeliveryChecked && deliveryDelay == null) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez remplir le délais de livraison',
        showConfirmButton: false,
        timer: 1500
      });
    } else if (this.allowDeliveryChecked && unitDeliveryDuration == null) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez choisir l\'unité de temps',
        showConfirmButton: false,
        timer: 1500
      });
    }*/

    let post: IPost = this.postUpdate;
    post.description = description;
    //post.postProducts[0].price = price;
    this.productUpdated.name = name;
    this.postService.updatePost(post).subscribe(data => {

     // console.log("Validation du produit à modifier");
     // console.log(this.productUpdated)

      this.productService.updateProduct(this.productUpdated).subscribe(rs=>{
      //  console.log("Modificationnnnnnnnnnnnnnnnnnnnnnnnnnnnnn");
      //  console.log(rs);
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Publication modifiée avec succès',
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadComponent();
      })

    }, error => {
    //  console.log(error);
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Erreur lors de la modification de la publication',
        showConfirmButton: false,
        timer: 1500
      });
    });
  }

  updateServPub() {
    //const price = this.updateServFormGroup.get(['price']).value;
    const name = this.updateServFormGroup.get(['name']).value;
    const description = this.updateServFormGroup.get(['description']).value;

    let post: IPost = this.postUpdate;
    // post.postServiceModels[0].price = price;
    post.description = description;
    this.serviceUpdated.titre = name;
   // console.log("Post Service modifier ...");
   // console.log(post);
    this.postService.updatePost(post).subscribe(data => {
      //console.log("postdata updated");
      //console.log(data);
      this.servService.updateService(this.serviceUpdated).subscribe(rs=>{
       // console.log("Service qu'on a modifier...");
       // console.log(rs);
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Publication modifiée avec succès',
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadComponent();
      });
    }, error => {
      // console.log(error);
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Erreur lors de la modification de la publication',
        showConfirmButton: false,
        timer: 1500
      });
    });
  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  /*hideDeliveryDayAndUnitTime() {
    this.allowDeliveryChecked = false;
  }*/

  /*showDeliveryDayAndUnitTime() {
    this.allowDeliveryChecked = true;
  }*/

  // Vérifier si l'id se trouve la liste des annonces que Kahpoo à mis en promotion
  isIdInPromotionPosts(id: number): boolean {
    return this.annonceEnPromotionDeKahpoo.includes(id);
  }

  // Récupérer la liste des annonces en promotion faite par kahpoo
  // listeAnnoncesEnPromotionDeKahpoo(): number[] {
  //       this.paramPromo =  new Param();
  //       this.paramService.getParamBySlug("promotion-kahpoo").subscribe(rs=>{
  //         this.paramPromo = rs;
  //        // console.log(" this.paramPromo ",  this.paramPromo )
  //         let paramValue = this.paramPromo?.value;

  //         if (paramValue !== null && paramValue !== undefined && paramValue.trim() !== "") {
  //             const idStrings: string[] = paramValue.split(",");
  //             for (const idString of idStrings) {
  //                 if (idString.trim() !== "") {
  //                     try {
  //                         const postId: number = parseInt(idString.trim(), 10);
  //                         this.annonceEnPromotionDeKahpoo.push(postId);
  //                     } catch (e) {
  //                     }
  //                 }
  //             }
  //         }
  //       });
  //       //console.log("Annonce mise promotion de kahpoo ..........");
  //       //console.log(this.annonceEnPromotionDeKahpoo);
  //       return this.annonceEnPromotionDeKahpoo;
  // }

  // nouvelle implémentation des promotios
  listeAnnoncesEnPromotionDeKahpoo(): number[] {

    this.promotionApplyService.getListPostIdPromotionAppy().subscribe(rs=>{
     // console.log("liii moy rs", rs);
      if (rs !== null && rs !== undefined) {
        this.annonceEnPromotionDeKahpoo = rs
        //console.log("liii moy highlightedPosts", this.highlightedPosts);
     }
    });


    return  this.annonceEnPromotionDeKahpoo;
}

  // annoneMiseEnAvantOld(): number[] {
  //       this.param =  new Param();
  //       this.paramService.getParamBySlug("post-mise-en-avant").subscribe(rs=>{
  //         this.param = rs;
  //         let paramValue = this.param?.value;

  //         if (paramValue !== null && paramValue !== undefined && paramValue.trim() !== "") {
  //             const idStrings: string[] = paramValue.split(",");
  //             for (const idString of idStrings) {
  //                 if (idString.trim() !== "") {
  //                     try {
  //                         const postId: number = parseInt(idString.trim(), 10);
  //                         this.highlightedPosts.push(postId);
  //                     } catch (e) {
  //                     }
  //                 }
  //             }
  //         }
  //       });

  //       console.log("Annonce mise en avant Old..........");
  //       console.log(this.highlightedPosts);
  //       return this.highlightedPosts;
  // }

  annoneMiseEnAvant(): number[] {

    this.postPromoteService.getListPostIdPromote().subscribe(rs=>{
     // console.log("liii moy rs", rs);
      if (rs !== null && rs !== undefined) {
        this.highlightedPosts = rs
        //console.log("liii moy highlightedPosts", this.highlightedPosts);
     }
    });


    return this.highlightedPosts;
}

  isIdInHighlightedPosts(id: number): boolean {
    return this.highlightedPosts.includes(id);
  }

  isIdInHighlightedPostsNew(id: number): Observable<boolean> {
    return this.postPromoteService.isIdInHighlightedPosts(id);
  }

  // mettreEnPromotionOld1(p: any) {
  //  // console.log(p);
   
  //   if(p.status?.name === "publié"){
  //     if((p.postSubProducts.length > 0 && this.kahooProductPromotionId) || (p.postServiceModels.length > 0 && this.kahooServicePromotionId)){
  //       Swal.fire({
  //         title: 'Voulez-vous ajouter cette annonce en promotion ?',
  //         icon: 'warning',
  //         showCancelButton: true,
  //         confirmButtonColor: '#3085d6',
  //         cancelButtonText: 'Non',
  //         confirmButtonText: 'Oui'
  //       }).then((result) => {
  //         if (result.isConfirmed) {
  //           if (!this.isIdInPromotionPosts(p.id)){
  //             this.annonceEnPromotionDeKahpoo.push(p.id);
  //             const value: string = this.annonceEnPromotionDeKahpoo.join(',');
  //             //console.log("Nouvelle liste");
  //             //console.log(value);
  //             this.paramPromo.value = value;
  //             //console.log("this.paramPromo.value ");
  //             //console.log(this.paramPromo);
  //             this.paramService.updateParam(this.paramPromo).subscribe(rs=>{
  //               Swal.fire({
  //                 position: 'top-end',
  //                 icon: 'success',
  //                 title: 'La publication a été ajoutée à la liste des annonces en promotion.',
  //                 showConfirmButton: false,
  //                 timer: 1500
  //               });
  //               this.reloadComponent();
  //             }, error => {
  //                 Swal.fire({
  //                   position: 'top-end',
  //                   icon: 'error',
  //                   title: error.error.errorMessage,
  //                   showConfirmButton: false,
  //                   timer: 1500
  //                 })
  //               });
  //           }else{
  //             Swal.fire({
  //               position: 'top-end',
  //               icon: 'error',
  //               title: 'Cette annonce est déjà dans la liste des annonces en promotion.',
  //               showConfirmButton: false,
  //               timer: 1500
  //             })
  //           }
  //         }
  //       });
  //     }else if(p.postSubProducts.length > 0 && (!this.kahooProductPromotionId || this.kahooProductPromotionId==undefined)){
  //       Swal.fire({
  //         position: 'top-end',
  //         icon: 'error',
  //         title: 'Veillez d\'abord activé une promotion de type produit.',
  //         showConfirmButton: false,
  //         timer: 2500
  //       })
  //     }else if(p.postServiceModels.length > 0 && (!this.kahooServicePromotionId || this.kahooServicePromotionId==undefined)){
  //       Swal.fire({
  //         position: 'top-end',
  //         icon: 'error',
  //         title: 'Veillez d\'abord activé une promotion de type service.',
  //         showConfirmButton: false,
  //         timer: 2500
  //       })
  //     }
  //   }else{
  //     Swal.fire({
  //       position: 'top-end',
  //       icon: 'error',
  //       title: 'Veillez d\'abord activé la publication.',
  //       showConfirmButton: false,
  //       timer: 2500
  //     })
  //   }

  // }

  // mettreEnAvant(p: any) {
  //   if(p.status?.name === "publié"){
  //     Swal.fire({
  //       title: 'Voulez-vous mettre en avant cette annonce ?',
  //       icon: 'warning',
  //       showCancelButton: true,
  //       confirmButtonColor: '#3085d6',
  //       cancelButtonText: 'Non',
  //       confirmButtonText: 'Oui'
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         if (!this.isIdInHighlightedPosts(p.id)){
  //           this.highlightedPosts.push(p.id);
  //           const value: string = this.highlightedPosts.join(',');
  //           console.log("Nouvelle liste");
  //           console.log(value);
  //           this.param.value = value;
  //           this.paramService.updateParam(this.param).subscribe(rs=>{
  //             Swal.fire({
  //               position: 'top-end',
  //               icon: 'success',
  //               title: 'La publication a été mise en avant avec succès.',
  //               showConfirmButton: false,
  //               timer: 1500
  //             });
  //             this.reloadComponent();
  //           }, error => {
  //               Swal.fire({
  //                 position: 'top-end',
  //                 icon: 'error',
  //                 title: error.error.errorMessage,
  //                 showConfirmButton: false,
  //                 timer: 1500
  //               })
  //             });
  //         }else{
  //           Swal.fire({
  //             position: 'top-end',
  //             icon: 'error',
  //             title: 'Cette annonce est déjà mis en avant.',
  //             showConfirmButton: false,
  //             timer: 1500
  //           })
  //         }
  //       }
  //     });
  //   }else{
  //     Swal.fire({
  //       position: 'top-end',
  //       icon: 'error',
  //       title: 'Veillez d\'abord activé la publication.',
  //       showConfirmButton: false,
  //       timer: 2500
  //     })
  //   }
  // }


  // nouvelle implémétation des promotion--> Mettre en promotion
  // mettreEnPromotionOld2(p: any) {
  //   // console.log(p);
    
  //    if(p.status?.name === "publié"){
  //      if((p.postSubProducts.length > 0 && this.kahooProductPromotionId) || (p.postServiceModels.length > 0 && this.kahooServicePromotionId)){
  //        Swal.fire({
  //          title: 'Voulez-vous ajouter cette annonce en promotion ?',
  //          icon: 'warning',
  //          showCancelButton: true,
  //          confirmButtonColor: '#3085d6',
  //          cancelButtonText: 'Non',
  //          confirmButtonText: 'Oui'
  //        }).then((result) => {
         
  //         let promo: IPromotion= {}
  //          if (result.isConfirmed) {
  //            if (!this.isIdInPromotionPosts(p.id)){
  //              this.promotionApplyService.savePromotionApply(promo, p.id).subscribe(rs=>{
  //                Swal.fire({
  //                  position: 'top-end',
  //                  icon: 'success',
  //                  title: 'La publication a été ajoutée à la liste des annonces en promotion.',
  //                  showConfirmButton: false,
  //                  timer: 1500
  //                });
  //                this.reloadComponent();
  //              }, error => {
  //                  Swal.fire({
  //                    position: 'top-end',
  //                    icon: 'error',
  //                    title: error.error.errorMessage,
  //                    showConfirmButton: false,
  //                    timer: 1500
  //                  })
  //                });
  //            }else{
  //              Swal.fire({
  //                position: 'top-end',
  //                icon: 'error',
  //                title: 'Cette annonce est déjà dans la liste des annonces en promotion.',
  //                showConfirmButton: false,
  //                timer: 1500
  //              })
  //            }
  //          }
  //        });
  //      }else if(p.postSubProducts.length > 0 && (!this.kahooProductPromotionId || this.kahooProductPromotionId==undefined)){
  //        Swal.fire({
  //          position: 'top-end',
  //          icon: 'error',
  //          title: 'Veillez d\'abord activé une promotion de type produit.',
  //          showConfirmButton: false,
  //          timer: 2500
  //        })
  //      }else if(p.postServiceModels.length > 0 && (!this.kahooServicePromotionId || this.kahooServicePromotionId==undefined)){
  //        Swal.fire({
  //          position: 'top-end',
  //          icon: 'error',
  //          title: 'Veillez d\'abord activé une promotion de type service.',
  //          showConfirmButton: false,
  //          timer: 2500
  //        })
  //      }
  //    }else{
  //      Swal.fire({
  //        position: 'top-end',
  //        icon: 'error',
  //        title: 'Veillez d\'abord activé la publication.',
  //        showConfirmButton: false,
  //        timer: 2500
  //      })
  //    }
 
  //  }


  mettreEnPromotion(p: any, post: any) {
    // console.log(p);
    
    if (!this.isIdInPromotionPosts(post.id)){
      this.promotionApplyService.savePromotionApply(p, post.id).subscribe(rs=>{
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'La publication a été ajoutée à la liste des annonces en promotion.',
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadComponent();
      }, error => {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 1500
          })
        });
    }else{
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Cette annonce est déjà dans la liste des annonces en promotion.',
        showConfirmButton: false,
        timer: 1500
      })
    }
 
   }
   showModalApplyPromotion() {
    const modalElement = document.getElementById('applyPromo');
    if (modalElement) {
      // Afficher le modal
      modalElement.classList.add('show');
      modalElement.style.display = 'block';
      // Ajouter la classe pour assombrir l'arrière-plan, si nécessaire
      document.body.classList.add('modal-open');
    }
  }

  hideModalApplyPromotion() {
    const modalElement = document.getElementById('applyPromo');
    if (modalElement) {
      // Cacher le modal
      modalElement.classList.remove('show');
      modalElement.style.display = 'none';
      // Supprimer la classe pour assombrir l'arrière-plan, si nécessaire
      document.body.classList.remove('modal-open');
    }
  }
  checkForShowApplyPromotion(p:any) {
    if(p?.postSubProducts?.length > 0) {
      this.listKahpooPromo = this.productPromotionId.filter(p => !p.isApplyToAll)
      //console.log ("this.listKahpooPromo", this.listKahpooPromo)
    } else{
      this.listKahpooPromo = this.servicePromotionId.filter(p=> !p.isApplyToAll)
    }
    this.postPromu = p
    // console.log("listKahpooPromo" , this.listKahpooPromo)
    if(p.status?.name === "publié"){
      if((p.postSubProducts.length > 0 && this.kahooProductPromotionId) || (p.postServiceModels.length > 0 && this.kahooServicePromotionId)){
        this.showModalApplyPromotion()
      }else if(p.postSubProducts.length > 0 && (!this.kahooProductPromotionId || this.kahooProductPromotionId==undefined)){
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Veillez d\'abord activé une promotion de type produit.',
          showConfirmButton: false,
          timer: 2500
        })
      }else if(p.postServiceModels.length > 0 && (!this.kahooServicePromotionId || this.kahooServicePromotionId==undefined)){
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Veillez d\'abord activé une promotion de type service.',
          showConfirmButton: false,
          timer: 2500
        })
      }
    }else{
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veillez d\'abord activé la publication.',
        showConfirmButton: false,
        timer: 2500
      })
    }

   }
  mettreEnAvant(p: any) {
    if(p.status?.name === "publié"){
      Swal.fire({
        title: 'Voulez-vous mettre en avant cette annonce ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonText: 'Non',
        confirmButtonText: 'Oui'
      }).then((result) => {
        if (result.isConfirmed) {
          if (!this.isIdInHighlightedPosts(p.id)){
            this.postPromoteService.enablePromoteByPostId(p.id).subscribe(rs=>{
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'La publication a été mise en avant avec succès.',
                showConfirmButton: false,
                timer: 1500
              });
              this.reloadComponent();
            }, error => {
                Swal.fire({
                  position: 'top-end',
                  icon: 'error',
                  title: error.error.errorMessage,
                  showConfirmButton: false,
                  timer: 1500
                })
              });
          }else{
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Cette annonce est déjà mis en avant.',
              showConfirmButton: false,
              timer: 1500
            })
          }
        }
      });
    }else{
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veillez d\'abord activé la publication.',
        showConfirmButton: false,
        timer: 2500
      })
    }
  }

  enleverDeLaListeDesAnnoncesMisEnPromotion(postid: number) {
    Swal.fire({
      title: 'Voulez-vous l\'enlever de la liste des annonces mise en promotion ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        
          this.promotionApplyService.deletePrmotionApplyByPostid(postid).subscribe(rs=>{
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'La publication a été enlevée dans la des annonces mise en promotion.',
              showConfirmButton: false,
              timer: 1500
            });
            this.reloadComponent();
          }, error => {
              Swal.fire({
                position: 'top-end',
                icon: 'error',
                title: error.error.errorMessage,
                showConfirmButton: false,
                timer: 1500
              })
          });
        
      }
    });
  }
  enleverDeLaListeDesAnnoncesMisEnAvant(id: number) {
    Swal.fire({
      title: 'Voulez-vous l\'enlever de la liste des annonces mise en avant ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.postPromoteService.deletePromoteFromPostId(id).subscribe(
          rs=> {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'La publication a été enlevée dans la des annonces mise en avant avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
            this.reloadComponent();
          }, error => {
           // console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 1500
            })
          }
        )
      }
    })
  }
  deletePost(id: number) {
    Swal.fire({
      title: 'Voulez-vous vraiment supprimer cette publication ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.postService.deletePost(id).subscribe(
          rs=> {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Publication supprimée avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
            this.reloadComponent();
          }, error => {
           // console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 1500
            })
          }
        )
      }
    })
  }

  exportPostToExelFile(filename: string) {
    const data = document.getElementById('tab-post');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(data);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, filename);
  }

  raiseTableSize(event: any) {
    this.pageSize = event.target.value;
    this.allPosts();
  }

  searchPost($event: KeyboardEvent) {
    this.posts = [];
    this.searchText = this.search !== undefined ? this.search : '';
    this.postService.allSellerPosts(this.pageNumber-1, this.pageSize, this.isFilterByProductAndService, this.isFilterByService, this.isFilterByProduct, this.beginDateVal, this.endDateVal, this.searchText, this.statusSearchText).subscribe(data => {
      this.posts = data.content;
      this.totalItems = data.totalElements;
      this.posts = this.filterByGiftCard(this.posts);
    });    
  }

  ascendingOrderDate: boolean = true;
  sortByDate() {
    this.posts.sort((a, b) => {
      const dateA = new Date(a.publishedAt);
      const dateB = new Date(b.publishedAt);
      if(this.ascendingOrderDate){
        return dateA.getTime() - dateB.getTime();
      }else{
        return dateB.getTime() - dateA.getTime();
      }
    })
    this.ascendingOrderDate = !this.ascendingOrderDate;
  }

  ascendingOrder: boolean = true;
  sortByAuthorFirstName(){
    this.posts.sort((a, b) => {
      const firstnameA = a.userID.firstname.toLowerCase();
      const firstnameB = b.userID.firstname.toLowerCase();

      if(this.ascendingOrder){
        return firstnameA.localeCompare(firstnameB);
      }else {
        return firstnameB.localeCompare(firstnameA);
      }
    })
    this.ascendingOrder = !this.ascendingOrder;
  }

  ascendingPhone: boolean = true;
  sortByPhoneNumber(){
    this.posts.sort((a, b) => {
      const phoneA = a.userID.phoneNumber.toLowerCase();
      const phoneB = b.userID.phoneNumber.toLowerCase();

      if(this.ascendingPhone){
        return phoneA.localeCompare(phoneB);
      }else {
        return phoneB.localeCompare(phoneA);
      }
    })
    this.ascendingPhone = !this.ascendingPhone;
  }

  ascendingOrderTitle: boolean = true;
  sortByTitle(){
    this.posts.sort((a, b) =>{
      if(this.ascendingOrderTitle){
        return a.title.toLowerCase().localeCompare(b.title.toLowerCase());
      }else{
        return b.title.toLowerCase().localeCompare(a.title.toLowerCase());
      }
    })
    this.ascendingOrderTitle = !this.ascendingOrderTitle;
  }

  ascendingOrderCategorie: boolean = true;
  sortByCategorie(){
    this.posts.sort((a, b) =>{
      if(this.ascendingOrderCategorie){
        return a.category?.name.toLowerCase().localeCompare(b.category?.name.toLowerCase());
      }else{
        return b.category?.name.toLowerCase().localeCompare(a.category?.name.toLowerCase());
      }
    })
    this.ascendingOrderCategorie = !this.ascendingOrderCategorie;
  }

  ascendingType: boolean = true;
  sortByType() {
    this.posts.map(p => {
      if (p.postProducts.length > 0 || p.postSubProducts.length > 0)
        p.type = "produit";
      else if (p.postServiceModels.length > 0)
        p.type = "service";
      else p.type = "";
    });
    //console.log(this.posts);
    this.posts.sort((a, b) =>{
      if(this.ascendingType){
        return a.type.toLowerCase().localeCompare(b.type.toLowerCase());
      }else{
        return b.type.toLowerCase().localeCompare(a.type.toLowerCase());
      }
    })
    this.ascendingType = !this.ascendingType;
  }

  
  filterByStatus(event: any) {
    this.posts = [];
    this.statusSearchText = event.target.value;
    if (this.statusSearchText === 'tous') {
     // this.pageSize = this.totalItems;
      
      this.statusSearchText = ''
      this.allPosts();
    } else {
      this.searchText = this.search !== undefined ? this.search : '';
      this.postService.allSellerPosts(this.pageNumber-1, this.pageSize, this.isFilterByProductAndService, this.isFilterByService, this.isFilterByProduct, this.beginDateVal, this.endDateVal, this.searchText, this.statusSearchText).subscribe(data => {
        this.posts = data.content;
        this.totalItems = data.totalElements;
        // console.log(this.totalItems)
        this.posts = this.filterByGiftCard(this.posts);
      }); 
    }
  }

  beginDateVal: any = null;
  displayErrorMessage: boolean = false;
  getBeginDate(event: any) {
    this.beginDateVal = event.target.value;
    if(this.beginDateVal != null){
      this.disableEndDate = false;
      if(this.beginDateVal > this.endDateVal){
        this.displayErrorMessage = true;
      }else {
        this.displayErrorMessage = false;
      }
    }
  }

  endDateVal: any = null;
  disableEndDate: boolean = true;
  getEndDate(event: any) {
    this.endDateVal = event.target.value;
  //  console.log(this.endDateVal);
    if(this.beginDateVal > this.endDateVal){
      this.displayErrorMessage = true;
    }else{
      this.displayErrorMessage = false;
    }
  }

  filterByDate() {
    const beginDate = new Date(this.dateForm.get('beginDate').value).toISOString();
    const endDate = new Date(this.dateForm.get('endDate').value).toISOString();
    // console.log("Date sélectionnée")
    // console.log('beginDate:', beginDate);
    // console.log('endDate:', endDate);
    if(!beginDate || !endDate) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      });
      return;
    }else{
      this.posts = [];
      this.searchText = this.search !== undefined ? this.search : '';
      this.postService.allSellerPosts(this.pageNumber-1, this.pageSize, this.isFilterByProductAndService, this.isFilterByService, this.isFilterByProduct, this.beginDateVal, this.endDateVal, this.searchText, this.statusSearchText).subscribe(data => {
        this.posts = data.content;
        this.totalItems = data.totalElements;
        this.posts = this.filterByGiftCard(this.posts);
      }); 
      // this.postService.getKahpooPostByDate(beginDate, endDate,this.pageNumber - 1, this.pageSize).subscribe(data =>{
      //   this.posts = data.content;
      //   this.totalItems = data.totalElements;
      // });
    }
  }

  filterPostByDate() {
    const beginDate = this.dateForm.get('beginDate').value;
    const endDate = this.dateForm.get('endDate').value;
    if(beginDate == '' || endDate == ''){
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      })
      return;
    }

    let endDateTrans: any = new Date(endDate);
    endDateTrans.setDate(endDateTrans.getDate() + 1);
    endDateTrans = this.datePipe.transform(endDateTrans,'yyyy-MM-dd');
    //console.log(endDateTrans);

    this.posts = this.initialPosts.filter(p => {
      return (p.publishedAt >= beginDate) && (p.publishedAt <= endDateTrans);
    })
  }

  refresh() {
    this.allPosts();
    this.dateForm.patchValue({
      beginDate: '',
      endDate: ''
    })
  }

  getUrlPhoto() {
    this.imageName = this.post.postSubProducts[0].subProduct?.photo;
    if(this.imageName != null || this.imageName != undefined){
      this.selected = true;
    }else {
      this.selected = false;
    }
  }

  getUrlPhoto1() {
    if(this.post.postSubProducts[0].subProduct?.photo1)
    this.imageName = this.post.postSubProducts[0].subProduct?.photo1;
    if(this.imageName != null || this.imageName != undefined){
      this.selected = true;
    }else {
      this.selected = false;
    }
  }

  getUrlPhoto2() {
    if(this.post.postSubProducts[0].subProduct?.photo2)
    this.imageName = this.post.postSubProducts[0].subProduct?.photo2;
    if(this.imageName != null || this.imageName != undefined){
      this.selected = true;
    }else {
      this.selected = false;
    }
  }

  selectedPhotoService: boolean = false;
  getUrlServicePhoto() {
   // console.log("photo")
    this.imageName = this.post.postServiceModels[0].serviceModel?.photo;
    if(this.imageName != null || this.imageName != undefined){
      this.selectedPhotoService = true;
      //console.log(this.selectedPhotoService)
    }else {
      this.selectedPhotoService = false;
    }
  }

  getUrlServicePhoto1() {
   // console.log("photo1")
    this.imageName = this.post.postServiceModels[0].serviceModel?.photo1;
    if(this.imageName != null || this.imageName != undefined){
      this.selectedPhotoService = true;
    }else {
      this.selectedPhotoService = false;
    }
  }

  getUrlServicePhoto2() {
   // console.log("photo2")
    this.imageName = this.post.postServiceModels[0].serviceModel?.photo2;
    if(this.imageName != null || this.imageName != undefined){
      this.selectedPhotoService = true;
    }else {
      this.selectedPhotoService = false;
    }
  }

  getUrlServicePhoto3() {
   // console.log("photo3")
    this.imageName = this.post.postServiceModels[0].serviceModel?.photo3;
    if(this.imageName != null || this.imageName != undefined){
      this.selectedPhotoService = true;
    }else {
      this.selectedPhotoService = false;
    }
  }

  getUrlServicePhoto4() {
    //console.log("photo4")
    this.imageName = this.post.postServiceModels[0].serviceModel?.photo4;
    if(this.imageName != null || this.imageName != undefined){
      this.selectedPhotoService = true;
    }else {
      this.selectedPhotoService = false;
    }
  }

  getUrlServicePhoto5() {
    //console.log("photo5")
    this.imageName = this.post.postServiceModels[0].serviceModel?.photo5;
    if(this.imageName != null || this.imageName != undefined){
      this.selectedPhotoService = true;
    }else {
      this.selectedPhotoService = false;
    }
  }

  postMiseEnAvant(posted:IPost){
    this.modalRef = this.modalService.show(AddPromoteComponent,{
      initialState:{posted},
      backdrop: false,
      ignoreBackdropClick: true
    });
  }

  strUcFirst(valeur : any){return (valeur+'').charAt(0).toUpperCase()+valeur.substr(1);}

  
  strUcFirst2(valeur : any){
    if(valeur != undefined){
      return valeur?.promotionItem[0]?.value0
    }
  }

  strUcFirst3(valeur : any){
    if(valeur != undefined){
      return valeur?.promotionItem[0]?.value1
    }
  }

  strUcFirst4(valeur : any){
    if(valeur != undefined){
      return valeur?.promotionItem[0]?.value2
    }
  }
  promo_selected_slug :any;
  product_error_message :boolean;
  service_error_message :boolean;
  getPromotion(id: any){
    this.promotionService.getIdPromotion(id).subscribe(rs =>{
      this.selectedPromotion = rs
      // console.log("Promotion sélectionné...");
      // console.log(this.selectedPromotion);
      if(this.selectedPromotion != undefined && this.selectedPromotion.promotionItem){
        this.getOfferTypeById(this.selectedPromotion?.promotionItem[0]?.typeOffer?.id);
        this.promo_selected_slug = this.selectedPromotion?.promotionItem[0]?.typeOffer?.slug;

        // console.log("Saved post promotion...");
        // console.log(this.posted);
        // console.log("PROMOTION sélectionné...");
        // console.log(this.promo_selected_slug);
        if(this.postPromu.postSubProducts[0] && !this.postPromu.postSubProducts[0]?.allowDelivery && (this.promo_selected_slug == "x-montant-reduit-sur-la-livraison-des-articles" || this.promo_selected_slug == "livraison-gratuite" || this.promo_selected_slug == "livraison-gratuite-a-partir-dun-x-montant-dachat")){
          this.product_error_message = true;
          // alert(this.product_error_message)
        }else{
          this.product_error_message = false;
        }
        if(this.postPromu.postServiceModels && !this.postPromu.postServiceModels[0]?.allowHomeService && (this.promo_selected_slug == "frais-de-deplacement-gratuit" || this.promo_selected_slug == "reduction-de-x-montant-sur-les-frais-de-deplacement")){
          this.service_error_message = true;
          // alert(this.service_error_message)
        }else{
          this.service_error_message = false;
        }
      }
    })
  }

  
  x_article_achete_y_article_offert = false;
  x_pourcent_de_reduction_produit  = false;
  livraison_gratuite = false;
  livraison_gratuite_x_montant = false;
  x_montant_reduit_sur_la_livraison_des_articles = false;
  x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
  x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
  x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;

  x_pourcent_de_reduction_service  = false;
  frais_de_deplacement_gratuit = false;
  reduction_de_x_montant_sur_les_frais_de_deplacement = false;
 
  selectedOfferTypeSlug : any;
  getOfferTypeById(id: any){
    this.typeOfferService.getIdTypeOffer(Number(id)).subscribe(rs=>{
      this.selectedOfferType = rs;
      // console.log("Type d'offre.........");
      // console.log(this.selectedOfferType);
      if(this.selectedOfferType != null && this.selectedOfferType !=undefined){
        this.selectedOfferTypeSlug = this.selectedOfferType?.slug;
        if(this.selectedOfferTypeSlug === "livraison-gratuite"){
          this.livraison_gratuite = true;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction_produit  = false;
          this.x_pourcent_de_reduction_service  = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuit = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
          this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
          this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
        }else if(this.selectedOfferTypeSlug === "x-pourcent-de-reduction-produit"){
          this.livraison_gratuite = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction_produit  = true;
          this.x_pourcent_de_reduction_service  = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuit = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
          this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
          this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
        }else if(this.selectedOfferTypeSlug === "x-pourcent-de-reduction-service"){
          this.livraison_gratuite = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction_produit  = false;
          this.x_pourcent_de_reduction_service = true;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuit = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
          this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
          this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
        }else if(this.selectedOfferTypeSlug === "livraison-gratuite-a-partir-dun-x-montant-dachat"){
          this.livraison_gratuite = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction_produit  = false;
          this.livraison_gratuite_x_montant = true;
          this.x_pourcent_de_reduction_service  = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuit = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
          this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
          this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
        }else if(this.selectedOfferTypeSlug === "x-montant-reduit-sur-la-livraison-des-articles"){
          this.livraison_gratuite = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction_produit  = false;
          this.x_pourcent_de_reduction_service  = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = true;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuit = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
          this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
          this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
        }else if(this.selectedOfferTypeSlug === "x-produit-achete-n-ieme-a-y-pourcent-de-reduction"){
          this.livraison_gratuite = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction_produit  = false;
          this.x_pourcent_de_reduction_service  = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = true;
          this.frais_de_deplacement_gratuit = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
          this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
          this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
        }else if(this.selectedOfferTypeSlug === "x-article-achete-y-article-offert"){
          this.livraison_gratuite = false;
          this.x_pourcent_de_reduction_service  = false;
          this.x_article_achete_y_article_offert = true;
          this.x_pourcent_de_reduction_produit  = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuit = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
          this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
          this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
        }else if(this.selectedOfferTypeSlug === "frais-de-deplacement-gratuit"){
          this.livraison_gratuite = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction_service  = false;
          this.x_pourcent_de_reduction_produit  = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuit = true;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
          this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
          this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
        }else if(this.selectedOfferTypeSlug === "reduction-de-x-montant-sur-les-frais-de-deplacement"){
          this.livraison_gratuite = false;
          this.x_pourcent_de_reduction_service  = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction_produit  = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuit = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = true;
          this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
          this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
        }else if(this.selectedOfferTypeSlug === "x-produit-achete-les-n-suivants-a-y-pourcent-de-reduction"){
          this.livraison_gratuite = false;
          this.x_pourcent_de_reduction_service  = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction_produit  = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuit = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
          this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = true;
          this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
        }else if(this.selectedOfferTypeSlug === "x-produit-achete-le-reste-a-y-pourcent-de-reduction"){
          this.livraison_gratuite = false;
          this.x_pourcent_de_reduction_service  = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction_produit  = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuit = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
          this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
          this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = true;
        }
      }
    });
  }

  get getPost() { return this.PromotionApplyForm.controls; }

  PromotionApplyForm = this.fb.group({
    promotion : new FormControl("" , [Validators.required]),
  });

  onPromotionApplyFormSubmit(): void {
    // alert(this.product_error_message +'-'+this.service_error_message)
    if(!this.product_error_message && !this.service_error_message){
      if(this.PromotionApplyForm.valid){
        let promo = new Promotion;
        promo = this.selectedPromotion
        // console.log("promo",promo)
        // console.log(this.postPromu.id)
        this.promotionApplyService.savePromotionApply(promo, this.postPromu.id).subscribe(rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Votre promotion a été appliquée avec succés.',
            showConfirmButton: false,
            timer: 1500
          });
          this.hideModalApplyPromotion()
          this.reloadComponent();
        }, error => {
          // console.log(error);
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 1500
          });
        });
      }else{
        // console.log("invalide form")
        // console.log(this.postPromotionForm.controls)
      }
    }
  }
}
